import React from "react";
import "./Loading.scss";

const getLoading = () => {
  const path = window.location.pathname;
  const turkishPaths = [
    "/automation",
    "/bilgiislem",
    "/teknisyen",
    "/tobacco",
    "/marketing",
    "/salesengineer",
    "/insankaynaklari",
    "/finansmuhasebe",
    "/kalitesurec",
  ];

  if (turkishPaths.includes(path)) {
    return "Form gönderiliyor...";
  }
  return "Form is being submitted...";
};

const LoadSpinner = ({ text }) => (
  <div>
    <div className="loading">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div className="sendingForm">{text || getLoading()}</div>
  </div>
);

export default LoadSpinner;
